import { render, staticRenderFns } from "./GeographySelector.vue?vue&type=template&id=565f338e&"
import script from "./GeographySelector.vue?vue&type=script&lang=js&"
export * from "./GeographySelector.vue?vue&type=script&lang=js&"
import style0 from "./GeographySelector.vue?vue&type=style&index=0&id=565f338e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports